import { Routes, Route } from "react-router-dom";
import { Suspense, lazy } from "react";
import PrivateRoute from "./components/Routes/Private";
import AdminRoute from "./components/Routes/AdminRoute";
import SalesExecutiveRoute from "./components/Routes/SalesExecutiveRoute";
import ScrollToTop from "./components/ScrollToTop";
// hey
const HomePage = lazy(() => import("./pages/HomePage"));
const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));
const Policy = lazy(() => import("./pages/Policy"));
const TermsAndCondition = lazy(() => import("./pages/TermsAndCondition"));
const RefundPolicy = lazy(() => import("./pages/RefundPolicy"));
const Pagenotfound = lazy(() => import("./pages/Pagenotfound"));
const Register = lazy(() => import("./pages/Auth/Register"));
const Login = lazy(() => import("./pages/Auth/Login"));
const VerifyEmail = lazy(() => import("./pages/Auth/VerifyEmail"));
const Dashboard = lazy(() => import("./pages/user/Dashboard"));
const ForgotPasssword = lazy(() => import("./pages/Auth/ForgotPasssword"));
const AdminDashboard = lazy(() => import("./pages/Admin/AdminDashboard"));
const CreateCategory = lazy(() => import("./pages/Admin/CreateCategory"));
const CreateSubCategory = lazy(() => import("./pages/Admin/CreateSubCategory"));
const CreateProduct = lazy(() => import("./pages/Admin/CreateProduct"));
const Users = lazy(() => import("./pages/Admin/Users"));
const Orders = lazy(() => import("./pages/user/Orders"));
const Profile = lazy(() => import("./pages/user/Profile"));
const Support = lazy(() => import("./pages/user/Support"));
const Products = lazy(() => import("./pages/Admin/Products"));
const UpdateProduct = lazy(() => import("./pages/Admin/UpdateProduct"));
const Search = lazy(() => import("./pages/Search"));
const ProductDetails = lazy(() => import("./pages/ProductDetails"));
const Categories = lazy(() => import("./pages/Categories"));
const CategoryProduct = lazy(() => import("./pages/CategoryProduct"));
const CartPage = lazy(() => import("./pages/CartPage"));
const AdminOrders = lazy(() => import("./pages/Admin/AdminOrders"));
const AdminOrderDetails = lazy(() => import("./pages/Admin/AdminOrderDetails"));
const Tickets = lazy(() => import("./pages/Admin/Tickets"));
const Brands = lazy(() => import("./pages/Brands"));
const Wishlist = lazy(() => import("./pages/Wishlist"));
const ReturnOrder = lazy(() => import("./pages/user/ReturnOrder"));
const ReturnOrders = lazy(() => import("./pages/user/ReturnOrders"));
const AdminReturnOrders = lazy(() => import("./pages/Admin/AdminReturnOrders"));
const SalesExecutiveDashboard = lazy(() => import("./pages/SalesExecutive/SalesExecutiveDashboard"));
const SalesExecutiveOrders = lazy(() => import("./pages/SalesExecutive/SalesExecutiveOrders"));
const AdminCreateUser = lazy(() => import("./pages/Admin/AdminCreateUser"));
const MarketX = lazy(() => import("./pages/Admin/MarketX"));
const AdminPlaceOrder = lazy(() => import("./pages/Admin/AdminPlaceOrder"));
const SalesExecutivePlaceOrder = lazy(() => import("./pages/SalesExecutive/SalesExecutivePlaceOrder"));
const AdminMarketXOrders = lazy(() => import("./pages/Admin/AdminMarketXOrders"));
const SalesExecutiveCustomers = lazy(() => import("./pages/SalesExecutive/SalesExecutiveCustomers"));
const AdminDiscounts = lazy(() => import("./pages/Admin/AdminDiscounts"));
const AdminInventory = lazy(() => import("./pages/Admin/AdminInventory"));
const AdminPrices = lazy(() => import("./pages/Admin/AdminPrices"));
const AdminSources = lazy(() => import("./pages/Admin/AdminSources"));
const UploadInventory = lazy(() => import("./pages/Admin/UploadInventory"));
const DamageReplacement = lazy(() => import("./pages/Admin/DamageReplacement"));
const AdminSalesTargets = lazy(() => import("./pages/Admin/AdminSalesTargets"));
const StockConversion = lazy(() => import("./pages/Admin/StockConversion"));

const SuspenseFallback = () => (
  <div className="lazy-fallback">
    <div className="spinner-border" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
    <p>Loading page…</p>
  </div>
);
function App() {
  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<SuspenseFallback />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/product/:slug" element={<ProductDetails />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/brands" element={<Brands />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route path="/category/:slug" element={<CategoryProduct />} />
          <Route path="/search" element={<Search />} />
          <Route path="/dashboard" element={<PrivateRoute />}>
            <Route path="user" element={<Dashboard />} />
            <Route path="user/orders" element={<Orders />} />
            <Route path="user/return-order/:orderId" element={<ReturnOrder />} />
            <Route path="user/return-orders" element={<ReturnOrders />} />
            <Route path="user/profile" element={<Profile />} />
            <Route path="user/support" element={<Support />} />
          </Route>
          <Route path="/dashboard" element={<AdminRoute />}>
            <Route path="admin" element={<AdminDashboard />} />
            <Route path="admin/profile" element={<Profile />} />
          </Route>
          
          <Route path="/dashboard" element={<AdminRoute permission="categories" />}>
            <Route path="admin/create-category" element={<CreateCategory />} />
            <Route path="admin/create-subcategory" element={<CreateSubCategory />} />
          </Route>
          
          <Route path="/dashboard" element={<AdminRoute permission="add-product" />}>
            <Route path="admin/create-product" element={<CreateProduct />} />
          </Route>
          
          <Route path="/dashboard" element={<AdminRoute permission="create-user" />}>
            <Route path="admin/create-user" element={<AdminCreateUser />} />
          </Route>
          
          <Route path="/dashboard" element={<AdminRoute permission="products" />}>
            <Route path="admin/products" element={<Products />} />
            <Route path="admin/product/:slug" element={<UpdateProduct />} />
          </Route>
          
          <Route path="/dashboard" element={<AdminRoute permission="users" />}>
            <Route path="admin/users" element={<Users />} />
            <Route path="admin/sales-targets" element={<AdminSalesTargets />} />
          </Route>
          
          <Route path="/dashboard" element={<AdminRoute permission="store-orders" />}>
            <Route path="admin/orders" element={<AdminOrders />} />
            <Route path="admin/order/:orderId" element={<AdminOrderDetails />} />
          </Route>
          
          <Route path="/dashboard" element={<AdminRoute permission="marketx-orders" />}>
            <Route path="admin/market-x-orders" element={<AdminMarketXOrders />} />
          </Route>
          
          <Route path="/dashboard" element={<AdminRoute permission="place-order" />}>
            <Route path="admin/place-order" element={<AdminPlaceOrder />} />
          </Route>
          
          <Route path="/dashboard" element={<AdminRoute permission="return-orders" />}>
            <Route path="admin/return-orders" element={<AdminReturnOrders />} />
          </Route>
          
          <Route path="/dashboard" element={<AdminRoute permission="tickets" />}>
            <Route path="admin/tickets" element={<Tickets />} />
          </Route>
          
          <Route path="/dashboard" element={<AdminRoute permission="discounts" />}>
            <Route path="admin/discounts" element={<AdminDiscounts />} />
          </Route>
          
          <Route path="/dashboard" element={<AdminRoute permission="inventory" />}>
            <Route path="admin/inventory" element={<AdminInventory />} />
            <Route path="admin/stock-conversion" element={<StockConversion />} />
          </Route>
          
          <Route path="/dashboard" element={<AdminRoute permission="upload-inventory" />}>
            <Route path="admin/upload-inventory" element={<UploadInventory />} />
          </Route>
          
          <Route path="/dashboard" element={<AdminRoute permission="damage-replacement" />}>
            <Route path="admin/damage-replacement" element={<DamageReplacement />} />
          </Route>
          
          <Route path="/dashboard" element={<AdminRoute permission="prices" />}>
            <Route path="admin/prices" element={<AdminPrices />} />
          </Route>
          
          <Route path="/dashboard" element={<AdminRoute permission="sources" />}>
            <Route path="admin/sources" element={<AdminSources />} />
          </Route>
          <Route path="/dashboard" element={<SalesExecutiveRoute />}>
            <Route path="sales-executive" element={<SalesExecutiveDashboard />} />
            <Route path="sales-executive/orders" element={<SalesExecutiveOrders />} />
            <Route path="sales-executive/my-customers" element={<SalesExecutiveCustomers />} />
            <Route path="sales-executive/place-order" element={<SalesExecutivePlaceOrder />} />
            <Route path="sales-executive/return-orders" element={<ReturnOrders />} />
            <Route path="sales-executive/profile" element={<Profile />} />
            <Route path="sales-executive/support" element={<Support />} />
          </Route>
          <Route path="/market-x" element={<MarketX />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPasssword />} />
          <Route path="/login" element={<Login />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<Policy />} />
          <Route path="/terms-condition" element={<TermsAndCondition />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="*" element={<Pagenotfound />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
